/**
 * StatCard — Icon + label + value display
 *
 * Used for: merchant dashboard summary stats (sales today, product count, etc.)
 */
import type { ReactNode } from 'react'
import { styled, YStack, Text as TamaguiText, type GetProps } from 'tamagui'
import { IconBadge } from '../elements/IconBadge'

const StatCardFrame = styled(YStack, {
  name: 'StatCard',
  bg: '$backgroundCard',
  br: '$lg',
  p: '$md',
  ai: 'center',
  gap: '$sm',
  minWidth: 120,
  animation: 'snap',
})

const StatLabel = styled(TamaguiText, {
  name: 'StatLabel',
  fontFamily: '$body',
  fontSize: 12,
  color: '$colorSecondary',
})

const StatValue = styled(TamaguiText, {
  name: 'StatValue',
  fontFamily: '$body',
  fontSize: 20,
  fontWeight: '700',
  color: '$color',
})

type StatCardFrameProps = GetProps<typeof StatCardFrame>

interface StatCardProps extends StatCardFrameProps {
  icon?: ReactNode
  label: string
  value: string
}

export const StatCard = StatCardFrame.styleable<StatCardProps>(
  ({ icon, label, value, ...props }, ref) => {
    return (
      <StatCardFrame ref={ref} {...props}>
        {icon && <IconBadge>{icon}</IconBadge>}
        <StatLabel>{label}</StatLabel>
        <StatValue>{value}</StatValue>
      </StatCardFrame>
    )
  },
)
